import { AntiBotMeta } from "../../constants/antiBot";
import { resolveAntiBotStrategy } from "../../hooks/antibot/strategies";
import { AntiBotNoticeText } from "./AntiBotNotice.styles";

type AntiBotNoticeProps = {
  antiBot?: AntiBotMeta | null;
  color?: string;
};

export const AntiBotNotice = ({ antiBot, color }: AntiBotNoticeProps) => {
  const strategy = antiBot ? resolveAntiBotStrategy(antiBot.provider) : null;

  if (!strategy?.attribution) {
    return null;
  }

  return (
    <AntiBotNoticeText color={color}>{strategy.attribution}</AntiBotNoticeText>
  );
};
